/// <amd-module name="Build/Admin/Checks/QueueChecksView" />
import React = require("react");

import { QueueChecksHub } from "Build/Admin/Checks/Components/QueueChecksHub";
import { Flux } from "Build/Admin/Checks/Flux";
import { ServiceIds, Telemetry } from "Build/Admin/Common/Constants";
import { HeaderBreadcrumbService } from "Build/Admin/Common/Services/HeaderBreadcrumbService";

import { VssComponent, IVssComponentContext, IVssComponentProperties } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class QueueChecksView extends VssComponent<IVssComponentProperties> {
    private _flux: Flux;
    private _breadcrumbService: HeaderBreadcrumbService;
    private _ttiMarked: boolean = false;
    private _dataReady: boolean = false;

    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);

        this._flux = new Flux(context.pageContext);

        this._flux.actionsHub.checkStoreStatusUpdated.addListener(this._markDataReady);

        this._flux.checksActionCreator.initializeCheckData();

        this._breadcrumbService = context.pageContext.getService<HeaderBreadcrumbService>(ServiceIds.HeaderBreadcrumbService);
        this._breadcrumbService.refresh({
            agentPool: this._flux.storesHub.selectionStore.state.selectedAgentPool,
            agentQueue: this._flux.storesHub.selectionStore.state.selectedAgentQueue,
            agent: undefined
        });
    }

    public componentWillUnmount(): void {
        this._flux.actionsHub.checkStoreStatusUpdated.removeListener(this._markDataReady);
    }

    public componentDidUpdate(): void {
        this._markTti();
    }

    private _markDataReady = (): void => {
        this._dataReady = true;
        this._markTti();
    }

    private _markTti(): void {
        if (this._dataReady && !this._ttiMarked) {
            this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService").markTimeToInteractive(Telemetry.Area, Telemetry.QueueChecksView);
            this._ttiMarked = true;
        }
    }

    public render(): JSX.Element {
        return (
            <QueueChecksHub storesHub={this._flux.storesHub} />
        )
    }
}

VssComponent.register("ms.vss-build-web.admin-checks-view-component", QueueChecksView);
